/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostCardStatus
 */
export interface HostCardStatus {
    /**
     * 
     * @type {number}
     * @memberof HostCardStatus
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HostCardStatus
     */
    state?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HostCardStatus
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof HostCardStatus
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HostCardStatus
     */
    description?: string;
}

export function HostCardStatusFromJSON(json: any): HostCardStatus {
    return HostCardStatusFromJSONTyped(json, false);
}

export function HostCardStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostCardStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function HostCardStatusToJSON(value?: HostCardStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'state': value.state,
        'code': value.code,
        'name': value.name,
        'description': value.description,
    };
}

